import api from '@/api'

const namespaced = true

const state = {
  routeOpt: [],
  ownerOpt: [],
  horsePowerOpt: [],
  bargeSizeOpt: [],
  siteOpt: []
}

const getters = {
  routeOpt: state => state.routeOpt,
  ownerOpt: state => state.ownerOpt,
  horsePowerOpt: state => state.horsePowerOpt,
  bargeSizeOpt: state => state.bargeSizeOpt,
  siteOpt: state => state.siteOpt
}

const mutations = {
  SET_ROUTE_OPT: (state, payload) => {
    state.routeOpt = payload
  },
  SET_OWNER_OPT: (state, payload) => {
    state.ownerOpt = payload
  },
  SET_HORSE_POWER_OPT: (state, payload) => {
    state.horsePowerOpt = payload
  },
  SET_BARGE_SIZE_OPT: (state, payload) => {
    state.bargeSizeOpt = payload
  },
  SET_SITE_OPT: (state, payload) => {
    state.siteOpt = payload
  }
}

const actions = {
  async getRouteOpt({ commit }, payload) {
    try {
      const { data } = await api.getRouteOpt(payload)

      if (data.error) {
        commit('SET_ROUTE_OPT', [])
        return
      }

      commit('SET_ROUTE_OPT', data)
    } catch (err) {
      throw err
    }
  },
  async getOwnerOpt({ commit }, payload) {
    try {
      const { data } = await api.getOwnerOpt(payload)

      if (data.error) {
        commit('SET_OWNER_OPT', [])
        return
      }

      commit('SET_OWNER_OPT', data)
    } catch (err) {
      throw err
    }
  },
  async getHorsePowerOpt({ commit }, payload) {
    try {
      const { data } = await api.getHorsePowerOpt(payload)

      if (data.error) {
        commit('SET_HORSE_POWER_OPT', [])
        return
      }

      commit('SET_HORSE_POWER_OPT', data)
    } catch (err) {
      throw err
    }
  },
  async getBargeSizeOpt({ commit }, payload) {
    try {
      const { data } = await api.getBargeSizeOpt(payload)

      if (data.error) {
        commit('SET_BARGE_SIZE_OPT', [])
        return
      }

      commit('SET_BARGE_SIZE_OPT', data)
    } catch (err) {
      throw err
    }
  },
  async getSiteOpt({ commit }, payload) {
    try {
      const { data } = await api.getSiteOpt(payload)

      if (data.error) {
        commit('SET_SITE_OPT', [])
        return
      }

      commit('SET_SITE_OPT', data)
    } catch (err) {
      throw err
    }
  }
}

export default { namespaced, state, getters, mutations, actions }